var map = {
	"./icon-commodities-big.svg": "dccd",
	"./icon-crypto-big.svg": "cb60",
	"./icon-ew-big.svg": "b97d",
	"./icon-forex-big.svg": "6453",
	"./icon-indian-big.svg": "9f5a",
	"./icon-indices-big.svg": "b6c9",
	"./icon-stocks-big.svg": "427c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa84";